<script lang="ts" setup>
import { defineComponent, reactive,defineProps, watch, computed, ref } from "vue";

import * as serviceDashboard from "@/services/DashboardInvestidor";
import ApexCharts from "apexcharts";

 interface IProps {
    planejado: serviceDashboard.PrevisaoDTO[],
    previsao: serviceDashboard.PrevisaoDTO[]
  }

var props = defineProps<IProps>();
  
var controle = reactive({
  visao: "vlrContratos",
    sales: [
      {
        name: "Planejado",
        data: [10,20,30,40,50,60,70,80],
      },
      {
        name: "Consolidado",
        data: [10,20,30,40,50,60,70,80],
      },
    ],
    weeklySalesChart: {
      chart: {
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "smooth",
      },
      colors: ["#6560F0", "#6FD3F7"],
      legend: {
        position: "top",
        fontSize: "14px",
        fontWeight: 500,
        horizontalAlign: "center",
        fontFamily: "Red Hat Display, sans-serif",
        labels: {
          colors: "#8E8DA1",
        },
        markers: {
          offsetY: -1,
          offsetX: -4,
          height: 15,
          width: 15,
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      grid: {
        show: true,
        strokeDashArray: 5,
        borderColor: "#d9e9ef",
      },
      tooltip: {
        style: {
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
        },
        y: {
          formatter: function (val: string) {
            return "$" + val + "K";
          },
        },
      },
      xaxis: {
        categories: props.planejado?.map(a=> a.mes),
        labels: {
          show: true,
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: "#9C9AB6",
            fontSize: "14px",
            fontWeight: 500,
          },
        },
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        tooltip: {
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: "#2b2a3f",
            fontSize: "14px",
          },
        },
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            fontFamily: "Red Hat Display, sans-serif",
            colors: ["#9C9AB6"],
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
    },
  });

watch(() => props.planejado, (newVal) => {
  controle.sales[0].data = newVal?.map(a => a.valorAcum);
});

watch(() => props.previsao, (newVal) => {
  controle.sales[1].data = newVal?.map(a => a.valorAcum);
});

const chartRef = ref();

function redefine(){
  console.log("redefinindo...");
  var newData = [] as number[] ;
  var newData2 = [] as number[] ;
  
  if (controle.visao == "qtdeContratos") {
    newData = props.planejado?.map(a => a.qtdeAcum) ?? [];
    newData2 = props.previsao?.map(a => a.qtdeAcum) ?? [];
  } else if (controle.visao == "vlrContratos") {
    newData = props.planejado?.map(a => a.valorAcum) ?? [];
    newData2 = props.previsao?.map(a => a.valorAcum) ?? [];
  } else if (controle.visao == "vlrMensal") {
    newData = props.planejado?.map(a => a.valor) ?? [];
    newData2 = props.previsao?.map(a => a.valor) ?? [];
  }

  chartRef.value?.updateSeries([
    { ...controle.sales[0], data: newData },
    { ...controle.sales[1], data: newData2 },
    
  ]);

  console.log("Dados atualizados");
  console.log(newData);
  console.log(newData2);
}


</script>

<template>
  <div class="card mb-25 border-0 rounded-0 bg-white sales-pos-location-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <span class="fw-bold fs-13 d-block mb-5 text-uppercase">
            Planejado X Consolidado
          </span>
          
        </div>
        <div
          class="card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5"
        >
          <span class="fw-medium text-muted me-8">Visão</span>
          <select v-model="controle.visao"
            class="form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium"
          @change="redefine()">
            <option value="qtdeContratos" class="fw-medium">Qtde Contratos</option>
            <option value="vlrContratos" class="fw-medium" selected>Valor Contratos</option>
            <option value="vlrMensal" class="fw-medium">Valor Mensal</option>
          </select>
        </div>
      </div>

      <div id="weeklySalesChart" class="chart" > 
        <apexchart
          ref="chartRef"
          type="line"
          height="375"
          :options="controle.weeklySalesChart"
          :series="controle.sales"
          
        ></apexchart>
      </div>
    </div>
  </div>
</template>

